import feedback from './feedback';
import footer from './footer';
import helpMenu from './helpMenu';
import navDrawer from './navDrawer';

export default {
  feedback,
  footer,
  helpMenu,
  navDrawer,
};
